/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Membercount1Inputs */

const en_entity_membercount1 = /** @type {(inputs: Entity_Membercount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member Count`)
};

const de_entity_membercount1 = /** @type {(inputs: Entity_Membercount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgliederanzahl`)
};

/**
* | output |
* | --- |
* | "Member Count" |
*
* @param {Entity_Membercount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_membercount1 = /** @type {((inputs?: Entity_Membercount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Membercount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_membercount1(inputs)
	return de_entity_membercount1(inputs)
});
export { entity_membercount1 as "entity_memberCount" }